<template>
  <!-- Program section -->
  <section>
    <!-- Program header -->
    <div class="event-section__title">Session scan</div>

    <div class="program-filters">
      <Switch 
        :buttons="['All', 'Past', 'Today', 'Future']"
        v-model="sessionFilter"
        @update:modelValue="filterPrograms()"
      />
    </div>

    <!-- Days scroll -->
    <div class="program-days mb-2">
      <!-- Program day -->
      <div
        v-for="(day, index) in programList"
        v-bind:key="index"
        @click="activeIndex = index"
        :class="{ active: activeIndex == index }"
        class="program-day"
      >
        <div class="program-day__day">
          {{ getDay(day.date) }}
        </div>
        <div class="program-day__date">
          {{ formatProgramDayDate(day.date) }}
        </div>
      </div>
    </div>

    <!-- Program list -->
    <div class="program-list">
      <!-- Program item -->
      <ProgramItem v-if="programList.length > 0"
        v-for="(program, index) in programList[activeIndex].programs"
        v-bind:key="index"
        :Program="program"
        @click="openProgram(program)"
      >
      </ProgramItem>
    </div>
  </section>
</template>

<script>
import ProgramItem from "./ProgramItemComponent.vue";
import Switch from "./Switch.vue";

export default {
  components: { ProgramItem, Switch },
  name: "ProgramComponent",
  props: {
    EventId: String,
    Event: null,
  },
  data: (props) => ({
    activeIndex: 0,
    sessionFilter: "All",
    programList: []
  }),
  emits: ["closeSwitchProgram"],
  methods: {
    formatDate(date) {
      return new Intl.DateTimeFormat("sl-SI", {
        dateStyle: "short",
      }).format(new Date(date));
    },
    formatProgramDayDate(date) {
      let options = {
        month: "short",
        day: "numeric",
      };

      return new Intl.DateTimeFormat("en-GB", options).format(new Date(date));
    },
    getDay(date) {
      const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      return days[new Date(date).getDay()];
    },
    openProgram(program) {
      program.eventId = this.EventId;

      this.$store.commit("setProgram", {
        program: program,
      });

      this.$store.commit("setEventProgramId", {
        eventProgramId: program.EventProgramID,
      });

      this.$store.commit("setEvent", {
        event: this.Event,
      });

      this.$store.commit("setProgramName", {
        programName: program.ProgramName,
      });

      this.$emit("closeSwitchProgram");
      this.$router.push("/program");
    },
    filterPrograms(){
      let programListFiltered = [];

      switch(this.sessionFilter){
        case "All":
          // this gives an object with dates as keys
          const groups = this.Event.programs.reduce((groups, program) => {
            const date = program.DtStart.split("T")[0];

            if (!groups[date]) {
              groups[date] = [];
            }

            groups[date].push(program);
            return groups;
          }, {});

          // Edit: to add it in the array format instead
          const groupArrays = Object.keys(groups).map((date) => {
            return {
              date,
              programs: groups[date],
            };
          });

          programListFiltered = groupArrays;
          break;
        case "Past":
          let pastPrograms = {};

          // Check if end date is before today's date
          this.Event.programs.forEach((program) => {
            if(new Date(program.DtEnd).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)){
              let date = program.DtStart.split("T")[0];

              if(!pastPrograms[date]){
                pastPrograms[date] = [];
              }

              pastPrograms[date].push(program);
            }
          })

          const pastGroupArrays = Object.keys(pastPrograms).map((date) => {
            return{
              date,
              programs: pastPrograms[date]
            }
          });

          programListFiltered = pastGroupArrays;
          break;
        case "Today":
          let todayPrograms = [];

          // Build an array with sessions happening on today's date
          this.Event.programs.forEach((program) => {
            if(new Date().setHours(0, 0, 0, 0) >= new Date(program.DtStart).setHours(0, 0, 0, 0) && new Date().setHours(0, 0, 0, 0) <= new Date(program.DtEnd).setHours(0, 0, 0, 0)){
              todayPrograms.push(program)
            }
          })

          if(todayPrograms.length > 0){
            // Create a date group array with the filtered sessions
            programListFiltered = [
            {
              date: new Date().toISOString().split("T")[0],
              programs: todayPrograms,
            }];
          }
          break;
        case "Future":
          let futurePrograms = {};

          // Check if start date is after today's date
          this.Event.programs.forEach((program) => {
            if(new Date(program.DtStart).setHours(0, 0, 0, 0) > new Date().setHours(0, 0, 0, 0)){
              let date = program.DtStart.split("T")[0];

              if(!futurePrograms[date]){
                futurePrograms[date] = [];
              }

              futurePrograms[date].push(program);
            }
          })
          
          const futureGroupArrays = Object.keys(futurePrograms).map((date) => {
            return{
              date,
              programs: futurePrograms[date]
            }
          });

          programListFiltered = futureGroupArrays;
          break;
      }

      // If "All" filter then set today's active index else set first element in array
      if(programListFiltered.length > 0 && this.sessionFilter == "All"){
          let todayIndex = programListFiltered.findIndex((program) => new Date(program.date).setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0));
          this.activeIndex = todayIndex != -1 ? todayIndex : 0;
        }
      else{
        this.activeIndex = 0;
      }

      this.programList = programListFiltered;
    },
  },

  mounted(){
    this.filterPrograms();
  }
};
</script>
